export const MOBILE_HOME = {
  nickname: 'PRODUCTS.MOBILE_HOME.nickname',
  properties: [
    { name: 'productPackage', key: 'PRODUCT_PACKAGE', group: 'INSURANCE_INFO' },
    { name: 'deductible', key: 'DEDUCTIBLE', group: 'INSURANCE_INFO' },
    { name: 'vehicleLicenseNumber', key: 'LICENSE_NUMBER', group: 'OBJECT_INFO' },
    { name: 'vehicleYoungDriver', key: 'YOUNG_DRIVER', group: 'INSURANCE_INFO' },
    { name: 'vehicleBonus', key: 'BONUS', group: 'INSURANCE_INFO' },
    { name: 'vehicleBonusYears', key: 'BONUS_YEARS', group: 'INSURANCE_INFO' },
    { name: 'vehicleDrivingLength', key: 'DRIVING_LENGTH', group: 'INSURANCE_INFO' },
    { name: 'vehicleDrivingLengthReadingKm', key: 'DRIVING_LENGTH_READING_KM', group: 'INSURANCE_INFO' }
  ],
  icon:'mobile-home'
};
